import { Spin } from '@nv/react-commons/src/Components'
import React from 'react'

export const Loading = () => null
export const PageLoading = props => <Spin style={{ marginTop: 16 }} {...props} />
